import { NgModule, ModuleWithProviders, inject } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import {
  DocumentApiService,
  CompanyApiService,
  ApiConfiguration,
  ApiConfigurationParams,
  AuditService,
  VersionNumberInterceptor,
} from '..';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DocumentApiService,
    CompanyApiService,
    ApiConfiguration,
    AuditService,
  ],
})
export class ApiModule {
  static forRoot(
    params: ApiConfigurationParams,
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params,
        },
      ],
    };
  }

  constructor() {
    const parentModule = inject(ApiModule, { optional: true, skipSelf: true });
    const http = inject(HttpClient, { optional: true });

    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.',
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575',
      );
    }
  }
}
